<script>
    let { closeCallback } = $props();
    let isMessageOpen = $state(false);
    let isDialogOpen = $state(false);
    let modalTitle = $state("");
    let modalBody = $state("");
    
    // State for customizable button labels
    let okText = $state("OK");
    let cancelText = $state("Cancel");

    let modalMessageEl;
    let modalDialogEl;
    let modalMessageInstance;
    let modalDialogInstance;    
    let modalCallback;
    let modalCancelCallback;

    // Refactored to accept an options object
    export function dialog(options = {}) {
        modalBody = options.message || "";
        modalTitle = options.title || "";
        modalCallback = options.callback;
        modalCancelCallback = options.cancelCallback;
        
        // Dynamic labels with fallback text
        okText = options.okText || "OK";
        cancelText = options.cancelText || "Cancel";
        
        modalDialogInstance = new bootstrap.Modal(modalDialogEl, {backdrop: true, keyboard: false});
        modalDialogInstance.show();
        isDialogOpen = true;
    }

    // Refactored to accept an options object
    export function showMessage(options = {}) {
        modalBody = options.message || "";
        modalTitle = options.title || "";
        modalCallback = options.callback;
        
        // Dynamic labels with fallback text
        okText = options.okText || "OK";
        
        modalMessageInstance = new bootstrap.Modal(modalMessageEl, {backdrop: true, keyboard: false});
        modalMessageInstance.show();
        isMessageOpen = true;
    }

    function toggleDialog() {
        isDialogOpen = !isDialogOpen;
        if (!isDialogOpen){
            modalDialogInstance?.hide();
            if (closeCallback) closeCallback();
        }
    }

    function toggleMessage() {
        isMessageOpen = !isMessageOpen;
        if (!isMessageOpen){
            modalMessageInstance?.hide();
            if (closeCallback) closeCallback();
        }
    }
</script>

<!-- Message Modal -->
<div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    bind:this={modalMessageEl}
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{modalTitle}</h5>
                <button type="button" class="btn-close" aria-label="Close" onclick={toggleMessage}></button>
            </div>

            <div class="modal-body">
                {@html modalBody}
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    onclick={() => {
                        if (modalCallback) modalCallback();
                        isMessageOpen = false;
                        modalMessageInstance?.hide();
                        if (closeCallback) closeCallback();
                    }}
                >
                    {okText}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Dialog Modal -->
<div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    bind:this={modalDialogEl}
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{modalTitle}</h5>
                <button type="button" class="btn-close" aria-label="Close" onclick={toggleDialog}></button>
            </div>

            <div class="modal-body">
                {@html modalBody}
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    onclick={() => {
                        if (modalCallback) modalCallback();
                        isDialogOpen = false;
                        modalDialogInstance?.hide();
                        if (closeCallback) closeCallback();
                    }}
                >
                    {okText}
                </button>

                <button
                    type="button"
                    class="btn btn-secondary"
                    onclick={() => {
                        if (modalCancelCallback) modalCancelCallback();
                        isDialogOpen = false;
                        modalDialogInstance?.hide();
                        if (closeCallback) closeCallback();
                    }}
                >
                    {cancelText}
                </button>
            </div>
        </div>
    </div>
</div>
